import React from "react";
import "../Styles/Business.css"; // ensure this matches the file too
import { useNavigate } from "react-router-dom";

const Business = () => {
  const navigate = useNavigate();

  return (
<div className="business-page">
  <button className="back-button" onClick={() => navigate("/services")}>
    ← Back to Services
  </button>

  <div className="header-container">
    <h2>💼 Moneygram and WIDIT Bill Payment Services(Massy Remittance Guyana)</h2>
  </div>

  <div className="info-row">
    <div className="left-column">
      <div className="section-container">
        <p>
          RCS is the ONLY Moneygram agent in the vicinity of Wakenaam! Where we handle money
          transfers for both international and local!
        </p>
      </div>
      <div className="section-container">
        <p>
          RCS also offer services on behalf of the Ministry of Human Services, authorized by WIDIT Bill Payment Services (Massy Remittance Guyana). We make it easy for our community residents, by offering Senior Pension
          payments and Public assistance payments <strong>EVERY WORKING DAY!</strong>
        </p>
      </div>
    </div>

    <div className="right-column">
      <div className="section-container">
        <h4>📌 DID YOU KNOW?</h4>
        <p>
          You can collect your pension and public assistance early!, thats correct, with RCS, you can collect your senior pension
          and public assistance payments in the last week of the current month for the next month! <strong>NO NEED TO WAIT ANYMORE!</strong>
        </p>
      </div>
      <div className="info-box">
  <h4>📱 DOWNLOAD THE WIDIT APP</h4>
  <p>
    Handle your own Moneygram transactions at your convenience. By downloading the official WIDIT app, you can initiate your
    transactions and confirm in-store at RCS! This saves you time and it’s hassle-free! With the WIDIT app, you can also 
    send your incoming transfers directly to your bank account.
  </p>

  <div className="download-buttons">
    <a
      href="https://play.google.com/store/apps/details?id=net.controlmoney.massyremittancedigital&pcampaignid=web_share"
      target="_blank"
      rel="noopener noreferrer"
      className="app-download-button"
    >
      Download for Android
    </a>
    <a
      href="https://apps.apple.com/gy/app/widit/id6479331820"
      target="_blank"
      rel="noopener noreferrer"
      className="app-download-button"
    >
      Download for iPhone
    </a>
  </div>
</div>

    </div>
  </div>
</div>

  );
};

export default Business;
